import { useCustomQuery } from '../graphql';

export const useCheckEmptyAssets = (enabled: boolean, workspaceId?: string) => {
  const { data, isLoading } = useCustomQuery({
    cacheKey: ['assets', 'count', workspaceId || 'none'],
    query: `
      query ListAssets($filter: ListAssetsFilter!, $page: PageRequest) {
        asset {
          listAssets(filter: $filter, page: $page) {
            count
            items { id }
          }
        }
      }
    `,
    variables: {
      filter: workspaceId
        ? { workspaceId, columns: ['id'] }
        : { columns: ['id'] },
      page: { limit: 1, offset: 0 },
    },
    options: { enabled },
  });
  const count = data?.asset?.listAssets?.count;
  return {
    isLoading: isLoading && enabled,
    emptyAssets: enabled ? count === 0 : false,
    count,
  };
};

export const useCheckEmptyActivities = (enabled: boolean, workspaceId?: string) => {
  const { data, isLoading } = useCustomQuery({
    cacheKey: ['activities', 'count', workspaceId || 'none'],
    query: `
      query FindIssues($filter: FindIssuesFilter, $page: PageRequest) {
        issue {
          findIssues(filter: $filter, page: $page) {
            count
            items { id }
          }
        }
      }
    `,
    variables: {
      filter: workspaceId ? { workspace: { eq: workspaceId } } : undefined,
      page: { limit: 1, offset: 0 },
    },
    options: { enabled },
  });

  const count = data?.issue?.findIssues?.count;

  return {
    isLoading: isLoading && enabled,
    emptyActivities: enabled ? count === 0 : false,
    count,
  };
};
